import { Text } from 'common-components/typography';
import React from 'react';
import CommonUtils from 'utilities/common-utils';
import { ROSTER_WEEKLY_CONFIG } from '../roster-weekly-config';

const { GROUP_ROW_HEIGHT } = ROSTER_WEEKLY_CONFIG;

interface RevenueColumnProps {
  showRevenue?: boolean;
  revenueAmount?: number;
}

export function RevenueColumn({ showRevenue = true, revenueAmount = 0 }: RevenueColumnProps) {
  const height = `${GROUP_ROW_HEIGHT}px`;
  return (
    <div className=' pv-small ph-small flex-column' style={{ height }}>
      {showRevenue && (
        <>
          <Text color='secondary' size='small'>
            REVENUE
          </Text>
          <Text size='regular'>{CommonUtils.formatPrice(revenueAmount)}</Text>
        </>
      )}
    </div>
  );
}
